import { StyleSheet, Platform } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
    label: {
        flex: 1,
        marginRight: 16,
        marginTop: 16,
        lineHeight: 24,
        color: Colors.thinDark,
        ...Platform.select({
            web: {
                marginTop: 0,
                marginLeft: 16
            }
        })
    },
    desc: {
        marginLeft: 16,
        lineHeight: 20,
        color: Colors.smoothGrey
    },
    checkBoxContainer: {
        flexDirection: 'row'
    },
    androidCheckBoxStyle: {
        marginTop: 12,
        marginRight: 12,
        marginLeft: 4
    },
    iosCheckBoxStyle: {
        height: 20,
        width: 20,
        marginVertical: 18,
        marginHorizontal: 16
    }
})

const checkBoxTintcolors = {
    true: Colors.ocean,
    false: Colors.veryLightPinkTwo
}

export default styles
export { checkBoxTintcolors }
